import React from "react";
import "./dashboard.scss";
import NewOffers from "./NewOffers";
import OffersChart from "./OffersChart";

const AdminDetailDashboard = ({ selectedFrequency }) => {
  return (
    <div className="summary w-full h-full p-4 offersChart" style={{minHeight: '200px'}}>
      <div className="flex flex-col sm:flex-col xl:flex-row justify-between w-full">
        <span className="text-[20px] font-poppins font-[600] text-[black] whitespace-nowrap">
          Offers Summary
        </span>
      </div>
      <NewOffers selectedFrequency={selectedFrequency} />
      <OffersChart className="sm:mt-[5%] 2xl:mt-[2%]" barThickness={8} />
    </div>
  );
};

export default AdminDetailDashboard;
